import { render, staticRenderFns } from "./CurrencyIcon.vue?vue&type=template&id=27212924&scoped=true&"
import script from "./CurrencyIcon.vue?vue&type=script&lang=ts&"
export * from "./CurrencyIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyIcon.vue?vue&type=style&index=0&id=27212924&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27212924",
  null
  
)

export default component.exports